import React, { Component } from 'react';
import { connect } from 'react-redux';
import PublicationSelector from "./PublicationSelector";
import { fetch_publications, select_publication } from "../redux/actions";
import Paginator from "../../hoc/Paginator/Paginator";
import Modal from "react-responsive-modal";
import { FaTimes } from "react-icons/fa";

class PublicationSelectorContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			viewerModal: false
		};
	};

	handleViewer = (viewerFileURL, viewerFileType) => {

		let myURL = "https://docs.google.com/viewer?url="+encodeURIComponent(viewerFileURL)+"&embedded=true&#view=fit";
		if(viewerFileType === 'xlsx')
			myURL = "https://view.officeapps.live.com/op/embed.aspx?src="+encodeURIComponent(viewerFileURL);
			

		this.setState({ viewerModal: true, viewerFileUrl: myURL});

	};
	onCloseViewerModal = () => {
		this.setState({ open: false, viewerModal: false });
	};

	onOpenViewerModal = () => {
		this.setState({ open: true, viewerModal: false });
	};

    componentDidMount() {
        this.props.fetch_publications(this.props.currentPage)
        localStorage.removeItem('searchValue');
        localStorage.removeItem('sortParams');
    }

    onPublicationSelect = (publication) => {

        if (publication.publicationId !== null) {
        	let myURL = "https://docs.google.com/viewer?url="+encodeURIComponent(publication.publicationFileUrl)+"&embedded=true";
			/*
			if(viewerFileType === 'xlsx')
				myURL = "https://view.officeapps.live.com/op/embed.aspx?src="+encodeURIComponent(publication.publicationFileUrl);
			*/

			this.setState({ viewerModal: true, viewerFileUrl: myURL});

        } else {
            //this.props.history.push("/publications/0");
        }
    };


    render() {
        let mainDisplay = <div className={"CorrectiveInfoText"}>Please upgrade to the SCADA Premium platform.</div>;

        if (true /*this.props.publicationEnabled*/) {
            mainDisplay = <React.Fragment>
                <PublicationSelector publications={this.props.publications.publications_in_current_page}
                    onPublicationClick={this.onPublicationSelect} />
                <Paginator
                    name={"publication-selector"}
                    totalPages={this.props.totalPages}
                    currentPage={this.props.currentPage}
                    setPage={this.props.fetch_publications} />
            </React.Fragment>
        }

        return (
            <React.Fragment>
        		<Modal
					open={this.state.viewerModal}
					onClose={this.onCloseViewerModal}
					className="viewermodal"
				>
					<div>
					<FaTimes className="closeicon"  onClick={this.onCloseViewerModal} />
					</div>
					<div className="ModalWindowViewer">
					
						<iframe 
							title="PreviewFile"
							width="95%"
							height="95%"
							scrolling="auto"
							src={this.state.viewerFileUrl}
							/>
					</div>
				</Modal>
                {mainDisplay}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        publications: state.publications,
        currentPage: state.publications.current_page,
        totalPages: state.publications.total_pages,
        publicationEnabled: true //state.firmSettings.publicationEnabled
    }
};

const mapDispatchToProps = dispatch => {
    return {
        fetch_publications: (page) => dispatch(fetch_publications(page)),
        select_publication: (publication_id) => dispatch(select_publication(publication_id))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PublicationSelectorContainer);


// WEBPACK FOOTER //
// ./src/publications/components/PublicationSelectorContainer.js